export enum SortDirections {
  Asc = 'asc',
  Desc = 'desc',
}
